export default {
  setAccounts(state, { accounts }) {
    state.accounts = accounts
  },
  reset(state) {
    state.accounts = null
  },
}
